export default __webpack_public_path__ + "assets/83acf8f06b6f67e2bc1b9d805f2e4378.jpg";